import React, { useState } from 'react';
import { Button, Modal } from 'antd';
const DoctorModal = ({ isModalOpen, setIsModalOpen, modalImg, modalName, modalRole, modalSpecialty, modalSubSpecialty1, modalSubSpecialty2, modalAbout,selectedLanguage }) => {
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <Modal className='dr-modal' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
                <div className='frth-des-doctor-modal-div'>
                    <div className='dr-modal-img'>
                        <img src={modalImg} alt="" />
                    </div>
                    <div className='dr-modal-info-div' style={{width:'50%'}}>
                        <div className='frth-des-dr-modal-data'>
                            <h1>
                                {modalName}
                            </h1>
                            <h3>
                                {modalRole}
                            </h3>
                            <div className='frth-des-dr-modal-txt-div'>
                                <div className='frth-des-dr-modal-txt-left-div'>
                                    {modalSpecialty ? <p>
                                        {selectedLanguage?.txt_speciality}
                                    </p> : null}
                                    {modalSubSpecialty1 ? <p>
                                        {selectedLanguage?.txt_sub_speciality}
                                    </p> : null}
                                    {modalSubSpecialty2 ? <p>
                                        {selectedLanguage?.txt_sub_speciality}
                                    </p> : null}
                                    {modalAbout ? <p>
                                        {selectedLanguage?.txt_about}
                                    </p> : null}
                                </div>
                                <div className='frth-des-dr-modal-txt-right-div'>
                                    {modalSpecialty ? <p>
                                        {modalSpecialty}
                                    </p> : null} 
                                    {modalSubSpecialty1 ? <p>
                                        {modalSubSpecialty1}
                                    </p> : null}
                                    {modalSubSpecialty2 ? <p>
                                        {modalSubSpecialty2}
                                    </p> : null}
                                    {modalAbout ? <ul>
                                        {
                                            modalAbout?.map((v, i) => {
                                                return (
                                                    <li>
                                                        {v}
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default DoctorModal;